import React from 'react';
import { connect } from 'react-redux';
import { Popover, OverlayTrigger } from 'react-bootstrap';
//style
import './logointeractive.styl';
//images
import logo from '../../media/logosmall.png';
//text input
import { InteractiveMapText as InteractiveMapTextEN } from '../../input-text/en/landing_page';
import { InteractiveMapText as InteractiveMapTextNL  } from '../../input-text/nl/landing_page';

class LogoInteractive extends React.Component {

  constructor(props){
    super(props);
    this.state = {'viewed': 'blink'};
    //topic goes into class to manage position
    this.topic = props.topic;
    //choose correct text from the file
    // this.title = InteractiveMapText[this.topic].title;
    // this.mainText = InteractiveMapText[this.topic].body;
    //pop-ups
    // this.popoverHoverFocus = (
    // <Popover id="popover-trigger-hover-focus">
    //   <p><strong>{this.title}</strong></p>
    //   <p>{this.mainText}</p>
    // </Popover>
    // );
    this.setLocale = this.setLocale.bind(this);
  }

  disableBlink = () => {
    this.setState({'viewed': 'seen'});
  }

  setLocale(locale) {
      this.InteractiveMapText = null;
      switch (this.props.locale) {
          case 'en':
              this.InteractiveMapText = InteractiveMapTextEN;
              break;
          case 'nl':
              this.InteractiveMapText = InteractiveMapTextNL;
              break;
          default:
              this.InteractiveMapText = InteractiveMapTextEN;
      }
  }

  render(){
    this.setLocale(this.props.locale)

    this.title = this.InteractiveMapText[this.topic].title;
    this.mainText = this.InteractiveMapText[this.topic].body;
    this.popoverHoverFocus = (
      <Popover id="popover-trigger-hover-focus">
        <p><strong>{this.title}</strong></p>
        <p>{this.mainText}</p>
      </Popover>
    );

    return (
      <div onMouseOver={this.disableBlink}>
        <div className={'interactive-container '+this.topic+' '+this.state.viewed}>
          <img className="interactive-logo" src={logo} alt='aircheckr-logo' />
        </div>
        <OverlayTrigger className='interactive-container-overlay' trigger={['hover', 'focus']} placement="top" overlay={this.popoverHoverFocus}>
          <div className={'interactive-container '+this.topic}>
            <img className="interactive-logo" src={logo} alt='aircheckr-logo' />
          </div>
        </OverlayTrigger>
      </div>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    locale: state.locale.value,
  };
};

export default connect(mapStateToProps, null)(LogoInteractive);



// WEBPACK FOOTER //
// ./src/components/logo/LogoInteractive.js